import { gql } from '@apollo/client'

export const INSURANCE_TESTS_RESULTS_ANALYTICS = gql`
  query InsuranceTestsResultsAnalyticsLazy(
    $filterData: InsuranceTestsResultsAnalyticsInput
    $pagination: PaginationInput!
  ) {
    insuranceTestsResultsAnalytics(filterData: $filterData, pagination: $pagination) {
      tests {
        id
        barcode
        testedAt
        result
        secondResult
        resultProvisionedAt
        resultVerifiedAt
        specimenType
        insuranceStatusWhenAdded
        insuranceUpdatedAt
        User {
          id
          firstName
          lastName
          birthDate
          email
          phoneNumber
          gender
          race
          ethnicity
          Address {
            street
            complement
            city
            state
            zip
            country
          }
        }
        TestSession {
          id
          date
          name
          lab
          type
          paymentStatus
          finishedAt
          invoiceId
          invoiceDocNumber
          Company {
            id
            name
          }
          zip
        }
        eventId
        eventpaymentMethod
        insuranceStatus
        Insurance {
          id
          insuranceCompany
          eligibilityStatus
          eligibilityErrorMessage
        }
        Group {
          name
        }
        Company {
          name
        }
      }
      pagination {
        from
        length
        total
      }
    }
  }
`
